import TabbedDisplay from 'modules/TabbedDisplay'

import ResearchBriefsPage from 'routes/common/FullReportPage/components/ResearchBriefs'

import { TableauEmbed } from 'components'

import { ISingleCustomPage } from 'interfaces/navigationPage.interface'

import { InfluenzaEpidemiologySlugs } from './InfluenzaEpidemiologyMenu'
import EpidDashboard from 'modules/EpidDashboard'

const EpidemiologyAcrossRespiratoryDiseases: ISingleCustomPage<InfluenzaEpidemiologySlugs> =
  {
    path: 'epidemiology-across-respiratory-diseases',
    component: () => <EpidDashboard />,
  }
const CasesDashboard: ISingleCustomPage<InfluenzaEpidemiologySlugs> = {
  path: 'cases',
  component: () => (
    <TableauEmbed path='/FRONTENDInfluenzadashboardsV2/Influenzacasedashboard' />
  ),
}
const StrainCirculationDashboard: ISingleCustomPage<InfluenzaEpidemiologySlugs> =
  {
    path: 'strain-circulation',
    component: () => (
      <TabbedDisplay
        tabs={[
          {
            heading: 'Distribution Map',
            body: (
              <TableauEmbed path='/FRONTENDnewInfluenzadashboards/DistributionMap' />
            ),
          },
          {
            heading: 'Global Time-Series',
            body: (
              <TableauEmbed path='/FRONTENDnewInfluenzadashboards/GlobalTimeseries' />
            ),
          },
        ]}
      />
    ),
  }
const USSeverityDashboard: ISingleCustomPage<InfluenzaEpidemiologySlugs> = {
  path: 'us-severity',
  component: () => (
    <TabbedDisplay
      tabs={[
        {
          heading: 'ILI',
          body: () => (
            <TableauEmbed path='/FRONTENDnewInfluenzadashboards/ILI' />
          ),
        },
        {
          heading: 'Hospitalisations',
          body: () => (
            <TableauEmbed path='/FRONTENDnewInfluenzadashboards/Hospitalisations' />
          ),
        },
      ]}
    />
  ),
}

const ResearchBriefs: ISingleCustomPage<InfluenzaEpidemiologySlugs> = {
  path: 'research-briefs',
  component: () => <ResearchBriefsPage />,
}

export const InfluenzaEpidemiologyCustomPages: Record<
  string,
  ISingleCustomPage<InfluenzaEpidemiologySlugs>
> = {
  EpidemiologyAcrossRespiratoryDiseases,
  StrainCirculationDashboard,
  USSeverityDashboard,
  ResearchBriefs,
  CasesDashboard,
}
